<template>
  <div>
    <h2>Formulario de Información de la Mujer Embarazada</h2>

     <div class="form-group">
      <div v-if="message" class="alert alert-danger" role="alert">
        <div v-for="(error, index) in message" :key="index">
          <span v-html="error.msg"></span>
        </div>
      </div>
    </div>
    <div class="row">
  <div class="col-md-6">
    <button class="btn btn-info btn-sm ml-auto">
      <router-link to="/registros" class="nav-link">
        <span class="text-white">Volver</span>
      </router-link>
    </button>
  </div>
</div>


    <form @submit.prevent="submitForm" class="needs-validation" novalidate>
      <!-- Fila 1 -->
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="hcu">HCU:</label>
            <input type="text" id="hcu" v-model="formData.hcu" class="form-control" required />
            <div class="invalid-feedback">Este campo es obligatorio.</div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="cedula">Cédula:</label>
            <input type="text" id="cedula" v-model="formData.cedula" class="form-control" required />
            <div class="invalid-feedback">Este campo es obligatorio.</div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="nombres">Nombres:</label>
            <input type="text" id="nombres" v-model="formData.nombres" style="text-transform:uppercase" class="form-control" required />
            <div class="invalid-feedback">Este campo es obligatorio.</div>
          </div>
        </div>
      </div>

      <!-- Fila 2 -->
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="apellidos">Apellidos:</label>
            <input type="text" id="apellidos" v-model="formData.apellidos" style="text-transform:uppercase" class="form-control" required />
            <div class="invalid-feedback">Este campo es obligatorio.</div>
          </div>
        </div>


        <div class="col-md-4">
          <div class="form-group">
            <label for="discapacidad">Discapacidad:</label>
            <select id="discapacidad" v-model="formData.discapacidad" class="form-control">
              <option value="Si">Sí</option>
              <option value="No">No</option>
            </select>
          </div>
        </div>

        <div class="col-md-4" v-if="formData.discapacidad === 'Si'">
        <div class="form-group">
          <label for="listadoDiscapacidades">Listado de Discapacidades:</label>
          <select id="listadoDiscapacidades" v-model="formData.detalleDiscapacidad" class="form-control">
            <option v-for="discapacidad in discapacidades" :key="discapacidad._id" :value="discapacidad.tipo">
              {{ discapacidad.tipo }}
            </option>
          </select>
        </div>
      </div>


        <div class="col-md-4">
          <div class="form-group">
            <label for="telfdomicilio">Teléfono Domicilio:</label>
            <input type="text" id="telfdomicilio" v-model="formData.telfdomicilio" class="form-control" />
          </div>
        </div>
      </div>

      <!-- Fila 3 -->
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="celular">Celular:</label>
            <input type="text" id="celular" v-model="formData.celular" class="form-control" />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="direccion">Dirección:</label>
            <input type="text" id="direccion" v-model="formData.direccion" style="text-transform:uppercase" class="form-control" />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="zona">Zona:</label>
            <input type="text" id="zona" v-model="formData.zona" style="text-transform:uppercase" class="form-control" />
          </div>
        </div>
      </div>

      <!-- Fila 4 -->
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="provincia">Provincia:</label>
            <select id="provincia" v-model="formData.provincia" class="form-control">
        <option v-for="provincia in provincias" :key="provincia.nombre" :value="provincia.nombre">
          {{ provincia.nombre }}
        </option>
      </select>
          </div>
        </div>
        <div class="col-md-4">
  <div class="form-group">
    <label for="canton">Cantón:</label>
    <select id="canton" v-model="formData.canton" class="form-control">
      <option v-for="canton in getCantones(formData.provincia)" :key="canton">
        {{ canton }}
      </option>
    </select>
  </div>
</div>

        <div class="col-md-4">
          <div class="form-group">
            <label for="parroquia">Parroquia:</label>
            <input type="text" id="parroquia" v-model="formData.parroquia" style="text-transform:uppercase"  class="form-control" />
          </div>
        </div>
      </div>

      <!-- Fila 5 -->
      <div class="row">
        <div class="col-md-4">
        <div class="form-group">
          <label for="establecimiento">Establecimiento:</label>
          <select id="establecimiento" v-model="formData.establecimiento" class="form-control">
            <option v-for="establecimiento in establecimientos" :key="establecimiento._id" :value="establecimiento.nombre">
              {{ establecimiento.nombre }}
            </option>
          </select>
        </div>
      </div>
        <!-- Puedes agregar más campos aquí -->
      </div>


      <!-- Fila 6 (Botón de enviar) -->
      <div class="row">
        <div class="col-md-12">
          <button type="submit" class="btn btn-primary">Guardar</button>
        </div>
      </div>
    </form>
    


  </div>
</template>

  
<script>
import axios from 'axios';
import swal from 'sweetalert';
import { BASE_URL } from '../store/config';

export default {
  computed:{
        currentUser() {
      return this.$store.state.auth.user;
    },
  },
  data() {
    return {
      message:'',
      formData: {
        hcu: '',
        cedula: '',
        nombres: '',
        apellidos: '',
        discapacidad: '',
        detalleDiscapacidad:'',
        telfdomicilio: '',
        celular: '',
        direccion: '',
        zona: '',
        provincia: '',
        canton: '',
        parroquia: '',
        establecimiento: '',
        createdBy: ''
      },
      provincias: [
  { nombre: 'AZUAY', cantones: ['CUENCA', 'GIRÓN', 'GUALACEO', 'NABÓN', 'PAUTE', 'PUCARA', 'SAN FERNANDO', 'SANTA ISABEL', 'SIGSIG', 'OÑA', 'CHORDELEG', 'EL PAN', 'SEVILLA DE ORO', 'GUACHAPALA', 'CAMILO PONCE ENRÍQUEZ'] },
  { nombre: 'BOLIVAR', cantones: ['GUARANDA', 'CHILLANES', 'CHIMBO', 'ECHEANDÍA', 'SAN MIGUEL', 'CALUMA', 'LAS NAVES'] },
  { nombre: 'CAÑAR', cantones: ['AZOGUES', 'BIBLIÁN', 'CAÑAR', 'LA TRONCAL', 'EL TAMBO', 'DÉLEG', 'SUSCAL'] },
  { nombre: 'CARCHI', cantones: ['TULCÁN', 'BOLÍVAR', 'ESPEJO', 'MIRA', 'MONTÚFAR', 'SAN PEDRO DE HUACA'] },
  { nombre: 'COTOPAXI', cantones: ['LATACUNGA', 'LA MANÁ', 'PANGUA', 'PUJILI', 'SALCEDO', 'SAQUISILÍ', 'SIGCHOS'] },
  { nombre: 'CHIMBORAZO', cantones: ['RIOBAMBA', 'ALAUSI', 'COLTA', 'CHAMBO', 'CHUNCHI', 'GUAMOTE', 'GUANO', 'PALLATANGA', 'PENIPE', 'CUMANDÁ'] },
  { nombre: 'EL ORO', cantones: ['MACHALA', 'ARENILLAS', 'ATAHUALPA', 'BALSAS', 'CHILLA', 'EL GUABO', 'HUAQUILLAS', 'MARCABELÍ', 'PASAJE', 'PIÑAS', 'PORTOVELO', 'SANTA ROSA', 'ZARUMA', 'LAS LAJAS'] },
  { nombre: 'ESMERALDAS', cantones: ['ESMERALDAS', 'ELOY ALFARO', 'MUISNE', 'QUININDÉ', 'SAN LORENZO', 'ATACAMES', 'RIOVERDE', 'LA CONCORDIA'] },
  { nombre: 'GUAYAS', cantones: ['GUAYAQUIL', 'ALFREDO BAQUERIZO MORENO (JUJÁN)', 'BALAO', 'BALZAR', 'COLIMES', 'DAULE', 'DURÁN', 'EL EMPALME', 'EL TRIUNFO', 'MILAGRO', 'NARANJAL', 'NARANJITO', 'PALESTINA', 'PEDRO CARBO', 'SAMBORONDÓN', 'SANTA LUCÍA', 'SALITRE (URBINA JADO)', 'SAN JACINTO DE YAGUACHI', 'PLAYAS', 'SIMÓN BOLÍVAR', 'CORONEL MARCELINO MARIDUEÑA', 'LOMAS DE SARGENTILLO', 'NOBOL', 'GENERAL ANTONIO ELIZALDE', 'ISIDRO AYORA'] },
  { nombre: 'IMBABURA', cantones: ['IBARRA', 'ANTONIO ANTE', 'COTACACHI', 'OTAVALO', 'PIMAMPIRO', 'SAN MIGUEL DE URCUQUÍ'] },
  { nombre: 'LOJA', cantones: ['LOJA', 'CALVAS', 'CATAMAYO', 'CELICA', 'CHAGUARPAMBA', 'ESPÍNDOLA', 'GONZANAMÁ', 'MACARÁ', 'PALTAS', 'PUYANGO', 'SARAGURO', 'SOZORANGA', 'ZAPOTILLO', 'PINDAL', 'QUILANGA', 'OLMEDO'] },
  { nombre: 'LOS RÍOS', cantones: ['BABAHOYO', 'BABA', 'MONTALVO', 'PUEBLOVIEJO', 'QUEVEDO', 'URDANETA', 'VENTANAS', 'VÍNCES', 'PALENQUE', 'BUENA FÉ', 'VALENCIA', 'MOCACHE', 'QUINSALOMA'] },
  { nombre: 'MANABÍ', cantones: ['PORTOVIEJO', 'BOLÍVAR', 'CHONE', 'EL CARMEN', 'FLAVIO ALFARO', 'JIPIJAPA', 'JUNÍN', 'MANTA', 'MONTECRISTI', 'PAJÁN', 'PICHINCHA', 'ROCAFUERTE', 'SANTA ANA', 'SUCRE', 'TOSAGUA', '24 DE MAYO', 'PEDERNALES', 'OLMEDO', 'PUERTO LÓPEZ', 'JAMA', 'JARAMIJÓ', 'SAN VICENTE'] },
  { nombre: 'MORONA SANTIAGO', cantones: ['MORONA', 'GUALAQUIZA', 'LIMÓN INDANZA', 'PALORA', 'SANTIAGO', 'SUCÚA', 'HUAMBOYA', 'SAN JUAN BOSCO', 'TAISHA', 'LOGROÑO', 'PABLO SEXTO', 'TIWINTZA'] },
  { nombre: 'NAPO', cantones: ['TENA', 'ARCHIDONA', 'EL CHACO', 'QUIJOS', 'CARLOS JULIO AROSEMENA TOLA'] },
  { nombre: 'PASTAZA', cantones: ['PASTAZA', 'MERA', 'SANTA CLARA', 'ARAJUNO'] },
  { nombre: 'PICHINCHA', cantones: ['QUITO', 'CAYAMBE', 'MEJIA', 'PEDRO MONCAYO', 'RUMIÑAHUI', 'SAN MIGUEL DE LOS BANCOS', 'PEDRO VICENTE MALDONADO', 'PUERTO QUITO'] },
  { nombre: 'TUNGURAHUA', cantones: ['AMBATO', 'BAÑOS DE AGUA SANTA', 'CEVALLOS', 'MOCHA', 'PATATE', 'QUERO', 'SAN PEDRO DE PELILEO', 'SANTIAGO DE PÍLLARO', 'TISALEO'] },
  { nombre: 'ZAMORA CHINCHIPE', cantones: ['ZAMORA', 'CHINCHIPE', 'NANGARITZA', 'YACUAMBI', 'YANTZAZA (YANZATZA)', 'EL PANGUI', 'CENTINELA DEL CÓNDOR', 'PALANDA', 'PAQUISHA'] },
  { nombre: 'GALAPAGOS', cantones: ['SAN CRISTÓBAL', 'ISABELA', 'SANTA CRUZ'] },
  { nombre: 'SUCUMBIOS', cantones: ['LAGO AGRIO', 'GONZALO PIZARRO', 'PUTUMAYO', 'SHUSHUFINDI', 'SUCUMBÍOS', 'CASCALES', 'CUYABENO'] },
  { nombre: 'ORELLANA', cantones: ['ORELLANA', 'AGUARICO', 'LA JOYA DE LOS SACHAS', 'LORETO'] },
  { nombre: 'SANTO DOMINGO DE LOS TSACHILAS', cantones: ['SANTO DOMINGO'] },
  { nombre: 'SANTA ELENA', cantones: ['SANTA ELENA', 'LA LIBERTAD'] }
],
      establecimientos: [], 
      discapacidades: []
    };
  },
  methods: {
    getCantones(provincia) {
    const provinciaSeleccionada = this.provincias.find(p => p.nombre === provincia);
    return provinciaSeleccionada ? provinciaSeleccionada.cantones : [];
  },
    submitForm() {
      this.formData.createdBy = this.currentUser.id;
      
      this.formData.nombres = this.formData.nombres.toUpperCase();
      this.formData.apellidos = this.formData.apellidos.toUpperCase();
      this.formData.direccion = this.formData.direccion.toUpperCase();
      this.formData.zona = this.formData.zona.toUpperCase();
      this.formData.provincia = this.formData.provincia.toUpperCase();
      this.formData.canton = this.formData.canton.toUpperCase();
      this.formData.parroquia = this.formData.parroquia.toUpperCase();
    
      axios.post(`${BASE_URL}/api/mujer`, this.formData, {
        headers: {
          'x-access-token': this.$store.state.auth.user.accessToken,
        },
      })
      .then(() => {
        swal({
          title: '¡Información Guardada!',
          text: 'La información de la madre ha sido guardada correctamente.',
          icon: 'success',
          button: 'OK',
        });

        this.$router.push('/lista/mujer');
   
    })
      .catch(error => {
        // Manejo de errores
        swal({
          title: 'Error',
          text: 'Hubo un error al guardar la información.',
          icon: 'error',
          button: 'OK',
        });
        this.message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
      });
    },
        //listado establecimiento
      async fetchEstablecimientos() {
      try {
        const response = await axios.get(`${BASE_URL}/api/establecimiento`, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        });
        this.establecimientos = response.data;
      } catch (error) {
        console.error('Error al obtener establecimientos de salud:', error);
      }
    },
     //LISTADO DISCAPACIDAD 
  async fetchDiscapacidades() {
      try {
        const response = await axios.get(`${BASE_URL}/api/discapacidad`, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        });
        this.discapacidades = response.data;
      } catch (error) {
        console.error('Error al obtener discapacidades:', error);
      }
    },
  },
  mounted() {
    this.fetchEstablecimientos();
    this.fetchDiscapacidades(); 
  },
};
</script>


<style scoped>
/* Estilos adicionales si es necesario */
</style>

